import { render, staticRenderFns } from "./PromosCustom.vue?vue&type=template&id=124f1e48&scoped=true&"
import script from "./PromosCustom.vue?vue&type=script&lang=js&"
export * from "./PromosCustom.vue?vue&type=script&lang=js&"
import style0 from "./PromosCustom.vue?vue&type=style&index=0&id=124f1e48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124f1e48",
  null
  
)

export default component.exports